import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { OrderLifetimeRuleAction } from '@cbridge-packages/order-lifetime-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onValidateOrderLifetimeRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    OrderLifetimeRuleAction.validate.done,
  ),
  mergeMap((payload) => {
    return [RulesManagementAction.applyValidation(payload.result)];
  }),
);
